import { atom } from 'jotai';
import { CURRENT_CAPTURE_ZOHO_LEADS_SCREEN, ZOHO_LEADS_FORM_KEYS, ZohoLeadsFormDetails } from '../typings';
import { phoneNumberAtom } from '../../login/v1/state';
import { atomWithDefault } from 'jotai/utils';

export const currentZohoLeadsFormScreenAtom = atom<CURRENT_CAPTURE_ZOHO_LEADS_SCREEN>(
  CURRENT_CAPTURE_ZOHO_LEADS_SCREEN.OTP
);

export const zohoLeadsFormDetailsAtom = atomWithDefault<ZohoLeadsFormDetails>((get) => {
  const phoneNumber = get(phoneNumberAtom);
  return {
    [ZOHO_LEADS_FORM_KEYS.COMPANY_NAME]: {
      value: '',
      isErrored: false,
    },
    [ZOHO_LEADS_FORM_KEYS.COUNTRY_CODE]: { value: phoneNumber.country },
    [ZOHO_LEADS_FORM_KEYS.PHONE_NUMBER]: { value: phoneNumber.phone, isErrored: false },
    [ZOHO_LEADS_FORM_KEYS.WEBSITE_URL]: {
      value: '',
      isErrored: false,
    },
    [ZOHO_LEADS_FORM_KEYS.BUSINESS_EMAIL]: {
      value: '',
      isErrored: false,
    },
  };
});

export const activeFeatureTabAtom = atom<number>(1);
